export default {
  /**
   * 支払方法設定要否判断
   */
  getMustHavePaymentCheck(){
    const res = {
      headers: {
        "content-type": "application/json"
      },
      data: {
        "isSetUpPaymentMethod": false
      },
      status: 200
    }
    return res
  },
}